import { Action } from '@ngrx/store';
import { Notification } from './notification.model';

export enum ActionTypes {
  NOTIFICATIONS = '[Notifications] Notifications',
  NOTIFICATIONS_REQUEST = '[Notification] Get Notifications',
  NOTIFICATIONS_FAILURE = '[Notification] Get Notifications Failure',
  MARK_AS_READ = '[Notification] Mark As Read',
  MARK_AS_READ_FAILURE = '[Notification] Mark As Read Failure',
}

export class NotificationsAction implements Action {
  readonly type = ActionTypes.NOTIFICATIONS;
  constructor(public payload: Notification[]) {}
}

export class NotificationsRequestAction implements Action {
  readonly type = ActionTypes.NOTIFICATIONS_REQUEST;
  constructor(public payload: any, public loader: boolean) {}
}

export class NotificationsRequestFailureAction implements Action {
  readonly type = ActionTypes.NOTIFICATIONS_FAILURE;
  constructor(public payload: { error: string }) {}
}

export class MarkAsReadAction implements Action {
  readonly type = ActionTypes.MARK_AS_READ;
  constructor(public payload: number) {}
}

export class MarkAsReadFailureAction implements Action {
  readonly type = ActionTypes.MARK_AS_READ_FAILURE;
  constructor(public payload: { error: string }) {}
}

export type Actions =
  | NotificationsAction
  | NotificationsRequestAction
  | NotificationsRequestFailureAction
  | MarkAsReadAction
  | MarkAsReadFailureAction;
